export const initialState = {
  bookings: [],
  facility: {
    name: '',
    description: '',
    services: [],
  },
  slotConfiguration: {
    dateRange: null,
    services: [],
  },
  grounds: [],
  seasons: [
    { id: 'peak', name: 'Peak Season', months: 'Mar - Sep', priceMultiplier: 1.2 },
    { id: 'standard', name: 'Standard Season', months: 'Oct - Feb', priceMultiplier: 1.0 },
    { id: 'offpeak', name: 'Off Season', months: 'Dec - Jan', priceMultiplier: 0.9 },
  ],
  teams: [],
  guests: [],
  slotAvailability: {},
};

export const bookingReducer = (state, action) => {
  switch (action.type) {
    case 'LOAD_BOOKINGS':
      return { ...state, bookings: action.payload || [] };
    case 'LOAD_FACILITY':
      return { ...state, facility: action.payload || { name: '', description: '', services: [] } };
    case 'ADD_BOOKING':
      return { ...state, bookings: [...state.bookings, action.payload] };
    case 'CANCEL_BOOKING':
      return {
        ...state,
        bookings: state.bookings.map((booking) =>
          booking.id === action.payload ? { ...booking, status: 'cancelled' } : booking
        ),
      };
    case 'ARCHIVE_BOOKING':
      return {
        ...state,
        bookings: state.bookings.map((booking) =>
          booking.id === action.payload ? { ...booking, status: 'archived' } : booking
        ),
      };
    case 'UPDATE_BOOKING_STATUS':
      return {
        ...state,
        bookings: state.bookings.map((booking) =>
          booking.id === action.payload.id ? { ...booking, status: action.payload.status } : booking
        ),
      };
    case 'UPDATE_PAYMENT_STATUS':
      return {
        ...state,
        bookings: state.bookings.map((booking) =>
          booking.id === action.payload.id
            ? {
                ...booking,
                advanceAmount: action.payload.newAdvance,
                balanceAmount: action.payload.newBalance,
                paymentStatus: action.payload.isFullyPaid ? 'fully_paid' : 'pending',
                paymentHistory: [
                  ...(booking.paymentHistory || []),
                  {
                    amount: action.payload.amountPaid,
                    date: action.payload.paymentDate,
                    paymentMode: action.payload.paymentMode,
                    paidBy: action.payload.paidBy,
                    mobile: action.payload.mobile,
                    timestamp: new Date().toISOString(),
                  },
                ],
                paymentDetails: {
                  ...(booking.paymentDetails || {}),
                  paymentMode: action.payload.paymentMode,
                },
              }
            : booking
        ),
      };
    case 'UPDATE_FACILITY':
      return {
        ...state,
        facility: {
          name: action.payload.name || state.facility.name,
          description: action.payload.description || state.facility.description,
          services: action.payload.services || state.facility.services,
        },
      };
    case 'UPDATE_SLOT_CONFIGURATION':
      return {
        ...state,
        slotConfiguration: {
          dateRange:
            action.payload.dateRange !== undefined ? action.payload.dateRange : state.slotConfiguration?.dateRange || null,
          services: action.payload.services !== undefined ? action.payload.services : state.slotConfiguration?.services || [],
        },
      };
    case 'ADD_SERVICE_CONFIGURATION':
      return {
        ...state,
        slotConfiguration: {
          ...state.slotConfiguration,
          services: [...(state.slotConfiguration?.services || []), action.payload],
        },
      };
    case 'UPDATE_SERVICE_CONFIGURATION':
      return {
        ...state,
        slotConfiguration: {
          ...state.slotConfiguration,
          services: (state.slotConfiguration?.services || []).map((config, index) =>
            index === action.payload.index ? action.payload.config : config
          ),
        },
      };
    case 'REMOVE_SERVICE_CONFIGURATION':
      return {
        ...state,
        slotConfiguration: {
          ...state.slotConfiguration,
          services: (state.slotConfiguration?.services || []).filter((_, index) => index !== action.payload),
        },
      };
    case 'CLEAR_ALL_DATA':
      return {
        ...initialState,
        bookings: [],
        facility: { name: '', description: '', services: [] },
        slotConfiguration: { dateRange: null, services: [] },
      };
    case 'LOAD_GROUNDS':
      return { ...state, grounds: Array.isArray(action.payload) ? action.payload : [] };
    default:
      return state;
  }
};
